import type { FaireProductEntity } from "../../entity_types/product";

export const p_tbacd935va: FaireProductEntity = {
  token: "p_tbacd935va",
  type: "product",
  name: "1 LB Wholesale - Rooibos Masala Chai Powder",
  brandToken: "b_wlog0i1yg7",
  brandName: "SØUL CHAI",
  imageUrl: "https://cdn.faire.com/fastly/3dc5167b48c2bb9ce69fea0efbe8ccf684dd8c51c856626b5455b8774f189ff1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b07e5a35d353c0c1187b45137d769c746d6e9deb58a7641c09c468aacc689e4.jpeg",
    "https://cdn.faire.com/fastly/ab463c8677b933af6d76be9b1082ba66a7ae5f1f5a40269ff376a0be7d2fd73a.jpeg",
    "https://cdn.faire.com/fastly/11a14091057311d4774bcc6e374e49dd711297bad3753fa01ed3680e81838efa.jpeg",
    "https://cdn.faire.com/fastly/36922f4b6229a90d14c65a889eeac262cbd67d6392fe8da56d196266dff86ad3.jpeg",
    "https://cdn.faire.com/fastly/2d7df20159d1b6e1124e602d4ccfd3f518b651787389ed7914b92f7b3b385f1b.jpeg"
  ],
  priceDollars: 76,
  description: "Naturally caffeine-free Rooibos Masala Soul Chai is a rich, velvety-delicious ode to Indian chai tradition. We spent years sourcing the most fragrant, nutty and earthy South African Rooibos for this blend and can't wait for you to taste it- our Rooibos Masala fans are die hard!\n\nDitch the wasteful, storage-heavy and sugary, watered-down flavor of tetra pak chai and enjoy 200+ servings of vibrant pure, organic spices + tea with no sweeteners or preservatives in this 1lb infinitely recyclable tin. \n\nBrewing Soul Chai by the cup or into a batched liquid concentrate is strainer-free and takes just minutes :)\n\n*For cafe service only, not available for resale.",
  tags: [],
  msrpDollars: 152,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:10.762Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
